import React from "react";
import PropTypes from "prop-types";
import { PoweredByQgiv } from "@qgiv/core-react";
import { SEO } from "@qgiv/core-donor";
import ConnectedFormStatusImage from "./ConnectedFormStatusImage";
import ConnectedBackButton from "./ConnectedBackButton";
import "./FormStatus.scss";

// Calls a function that returns the appropriate string of CMS text and
// replaces the %EventName% tag when necessary
const FormStatusMessage = ({ renderMessage }) => <>{renderMessage()}</>;

FormStatusMessage.propTypes = {
    renderMessage: PropTypes.func.isRequired,
};

const FormStatus = ({ renderMessage, documentTitle }) => (
    <div className="form-status">
        <SEO title={documentTitle} description="" />
        <div className="grid">
            <div className="col col--12 form-status__image-container">
                <ConnectedFormStatusImage />
            </div>
            <div className="col col--12">
                <h2 className="form-status__text">
                    <FormStatusMessage renderMessage={renderMessage} />
                </h2>
            </div>
            <div className="col col--12 form-status__back-button-container">
                <ConnectedBackButton />
            </div>
            <div className="col col--12 form-status__powered-by-qgiv-container">
                <PoweredByQgiv dark />
            </div>
        </div>
    </div>
);

FormStatus.propTypes = {
    renderMessage: PropTypes.func.isRequired,
    documentTitle: PropTypes.string.isRequired,
};

export default FormStatus;
